import DeleteBlogAPI from "./deleteBlogAPI";

const DeleteBlogService = async (id: string): Promise<any> => {
  try {
    return await DeleteBlogAPI(id);
  } catch (error) {
    throw error;
  }
};

export default DeleteBlogService;
